import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="bg-cream py-24 md:py-36" data-testid="testimonials">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal className="max-w-2xl mb-16">
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">Loved By</span>
          <h2 className="mt-5 font-serif text-4xl md:text-6xl leading-[0.95] text-obsidian">
            Results people<br /><span className="italic">feel.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {items.map((t, i) => (
            <Reveal key={i} delay={i * 0.06} className="bg-cream p-8 flex flex-col">
              <div className="flex gap-1 text-amber">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="mt-5 font-serif text-xl leading-snug text-obsidian flex-1">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-black/10">
                <p className="font-sans text-sm text-obsidian">{t.name}</p>
                <p className="font-sans font-light text-xs text-obsidian/50">{t.location} · {t.concern}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
